import { imageUrl } from '@helpers/image';
import ClearButton from '@stories/Components/ClearButton/ClearButton';
import * as React from 'react';
import S from './ColourPicker.styles';
const ColourPicker = ({ activeFilter, allowFiltering, colours, filterValues, onClick, onReset, title, }) => {
    if (!colours.length) {
        return null;
    }
    return (React.createElement(S.Container, { "data-portrait": !!colours.find((c) => !!c.isPortrait) },
        React.createElement(S.TitleWrapper, null,
            React.createElement(S.Title, null, title),
            React.createElement(ClearButton, { label: "Remove", onClick: () => onReset(), "data-visible": !!allowFiltering && !!colours.find((colour) => colour.value === activeFilter) })),
        React.createElement(S.Options, null, colours.map((colour) => (React.createElement(S.Option, { key: `colour-picker-${colour.value}` },
            React.createElement(S.Button, { "data-disabled": !filterValues.includes(colour.value), disabled: !filterValues.includes(colour.value), "data-active": activeFilter === colour.value, ...(allowFiltering ? { onClick: () => onClick(colour.value) } : { disabled: true }) },
                React.createElement(S.Border, null,
                    React.createElement(S.ImageContainer, null,
                        React.createElement(S.Image, { src: imageUrl(colour.image, { width: 127 }), alt: colour.label, loading: "lazy" })),
                    colour.isNew && React.createElement(S.Tag, null, "New")),
                React.createElement(S.Label, null, colour.label))))))));
};
export default ColourPicker;
